import {Injectable} from '@angular/core';
import {applicationStatus} from '../../compare/compare.service';
// import {BitlyComponent} from '../../../bitly/bitly/bitly.component';
// import {AggregatorComponent} from '../../../bitly/aggregator/aggregator.component';
// import {TermsOfServiceComponent} from '../../../bitly/terms-of-service/terms-of-service.component';
// import {EnachComponent} from '../../../bitly/enach/enach.component';
// import {KycComponent} from '../../../bitly/kyc/kyc.component';
// import {ChangeAddressComponent} from '../../../bitly/change-address/change-address.component';
// import {AccountComponent} from '../../../bitly/account/account.component';
// import {RegisterComponent} from '../../../bitly/register/register.component';
// import {StatusComponent} from '../../../bitly/status/status.component';
// import {VerifyDetailsComponent} from '../../../bitly/verify-details/verify-details.component';

@Injectable({
  providedIn: 'root'
})
export class StateTransitionsCustomerService {

  constructor() {
  }

  findAllowedRoute(loanDetails: any) {
    const routeTo = {
      [applicationStatus.LOAN_DETAILS]: null,
      [applicationStatus.USER_BASIC_DETAILS]: null,
      [applicationStatus.RESIDENCE_DETAILS]: null,
      [applicationStatus.CIBIL_APPLIED]: null,
      [applicationStatus.CIBIL_PROGRESS]: null,
      [applicationStatus.CIBIL_APPROVED]: '',
      // If you want to have mandotory for approved application. 
      // (() => {
      //   if (loanDetails) {
      //     if (loanDetails.accountAggregatorCheck > 0 ) return '';
      //     return '/aggregator';
      //   }
      //   return null;
      // })(),
      [applicationStatus.CUSTOMER_INIT]: (() => {
        if (loanDetails) {
          if (!loanDetails.offlineKYC && loanDetails.kycCompleted) return '/enach';
          if (loanDetails.offlineKYC) { // Aadhar uploaded;
            if (loanDetails.forceDocumentUpload && !loanDetails.kycCompleted) return '/kyc';
            // If the current address different from permanent and he did'nt upload address proof, let him upload address proof
            if (loanDetails.Customer.residentAddressDifferentFromPermanent && !loanDetails.kycCompleted) return '/change-address';
            //Navigate to verifyDetails
            if (loanDetails.kycCompleted) return '/verifyDetails';
            // Navigate to account
            return '/enach';
          }
          // if Aadhar is not uploaded, let him upload the documents
          return '/kyc';
        }
        return null;
      })(),
      [applicationStatus.PAYMENT_DONE]: '/enach',
      [applicationStatus.ENACH_ENABLED]: '/enach',
      [applicationStatus.APPLICATION_SUBMITTED]: (() => {
        if (loanDetails) {
          if (loanDetails.termsConditionsAccepted && loanDetails.Customer.isSignedUp) return '/status';
          if (loanDetails.termsConditionsAccepted && !loanDetails.Customer.isSignedUp) return '/account';
          return '/termsOfService';
        }
        return null;
      })(),
      /*[applicationStatus.APPLICATION_SUBMITTED]: (() => {
        if (!loanDetails.Customer.isSignedUp) return '/account';
        return '/status';
      })(),*/
      [applicationStatus.DISBURSED]: '/status',
      [applicationStatus.REJECTED]: '/aggregator',
      [applicationStatus.CANCELLED]: '/status'
    }[loanDetails.applicationStatus];

    return routeTo === null || routeTo === undefined ? null : routeTo;
  }

  isRequestedRouteAllowed(requestedComponent: any, loanDetails: any) {
    let isAccountAndRegisterAllowed = () => {
      if (applicationStatus.APPLICATION_SUBMITTED === loanDetails.applicationStatus && loanDetails.termsConditionsAccepted) {
        return !loanDetails.Customer.isSignedUp;
      }
      return false;
    };
    // if (requestedComponent === AggregatorComponent) {
    //   // If You want have mandatory step for approved cases(Helps in income docs - credit)
    //   //return [applicationStatus.REJECTED, applicationStatus.CIBIL_APPROVED].indexOf(loanDetails.applicationStatus) !== -1 &&
    //   return [applicationStatus.REJECTED, applicationStatus.CIBIL_APPROVED].indexOf(loanDetails.applicationStatus) !== -1 &&
    //     loanDetails && loanDetails.completedPartnerFlow;
    // }
    // if (requestedComponent === BitlyComponent) {
    //   return [applicationStatus.CIBIL_APPROVED].indexOf(loanDetails.applicationStatus) !== -1 &&
    //   // If you want to have mandotory for approved application and if waived then only move to insurance page
    //   // loanDetails && loanDetails.completedPartnerFlow && loanDetails.accountAggregatorCheck > 0;
    //     loanDetails && loanDetails.completedPartnerFlow;
    // }
    // if (requestedComponent === TermsOfServiceComponent) {
    //   return [applicationStatus.APPLICATION_SUBMITTED].indexOf(loanDetails.applicationStatus) !== -1 && !loanDetails.termsConditionsAccepted;
    // }
    // if (requestedComponent === EnachComponent) {
    //   return [applicationStatus.PAYMENT_DONE, applicationStatus.ENACH_ENABLED].indexOf(loanDetails.applicationStatus) !== -1 ||
    //     [applicationStatus.CUSTOMER_INIT].indexOf(loanDetails.applicationStatus) !== -1 ;
    // }
    // if (requestedComponent === KycComponent) {
    //   return [applicationStatus.CUSTOMER_INIT].indexOf(loanDetails.applicationStatus) !== -1
    //     && (!loanDetails.offlineKYC || loanDetails.forceDocumentUpload) && !loanDetails.kycCompleted;
    // }
    // if (requestedComponent === ChangeAddressComponent) {
    //   return [applicationStatus.CUSTOMER_INIT].indexOf(loanDetails.applicationStatus) !== -1
    //     && loanDetails.offlineKYC && loanDetails.Customer.residentAddressDifferentFromPermanent && !loanDetails.kycCompleted;
    // }
    // if (requestedComponent === VerifyDetailsComponent) {
    //   return [applicationStatus.CUSTOMER_INIT].indexOf(loanDetails.applicationStatus) !== -1 && loanDetails.offlineKYC;
    // }
    // if (requestedComponent === AccountComponent) {
    //   return isAccountAndRegisterAllowed();
    // }
    // if (requestedComponent === RegisterComponent) {
    //   return isAccountAndRegisterAllowed();
    // }
    // if (requestedComponent === StatusComponent) {
    //   return [
    //       applicationStatus.CIBIL_APPLIED,
    //       applicationStatus.CIBIL_PROGRESS,
    //       applicationStatus.CIBIL_APPROVED,
    //       applicationStatus.CANCELLED,
    //       applicationStatus.REJECTED,
    //       applicationStatus.DISBURSED,
    //     ].indexOf(loanDetails.applicationStatus) !== -1
    //     || (loanDetails.applicationStatus === applicationStatus.APPLICATION_SUBMITTED && loanDetails.kycCompleted && !loanDetails.isSignedUp);
    // }
    return false;
  }
}
